export type ReadonlyAuthorityEndpoints = {
    readonly SaveAuthority: string;
    readonly GetAuthority: string;
    readonly GetAuthorityById: string;
    readonly UpdateAuthority: string;
    readonly DeleteAuthority: string;
  };
  
  const controller = 'api/Authority'
  
  const AuthorityEndpoints: ReadonlyAuthorityEndpoints = {
    SaveAuthority: `${controller}/AddUpdateAuthority`,
    GetAuthority: `${controller}/GetAuthoritys`,
    GetAuthorityById: `${controller}/GetSiteById`,
    UpdateAuthority: `${controller}/AddUpdateAuthority`,
    DeleteAuthority: `api/Authority`,
  };
    

  export { AuthorityEndpoints };
  
  